export const REGIONS_WITHOUT_COM = [
  'mahachkala',
  'kirov',
  'bryansk',
  'vologda',
  'ulan-ude',
  'ivanovo',
  'kurgan',
  'orel',
  'kostroma',
  'pskov',
  'blagoveschensk',
  'birobidzhan',
  'chita',
  'nalchik',
  'petropavlovsk-kamchatskiy',
  'cherkessk',
  'magadan',
  'murmansk',
  'maykop',
  'gorno-altaysk',
  'nazran',
  'petrozavodsk',
  'syktyvkar',
  'yoshkar-ola',
  'saransk',
  'yakutsk',
  'vladikavkaz',
  'kyzyl',
  'abakan',
  'yuzhno-sahalinsk',
  'groznyy',
  'yanao',
];
